import { produce } from 'immer';
import { createJSONStorage } from 'zustand/middleware';

import { AmaHashParams, StoreHelper } from '@helpers';

export interface AmaState {
	isAmaRedirect?: boolean;
	hashParams?: AmaHashParams;
}

export const initialAmaState: AmaState = {
	isAmaRedirect: undefined,
	hashParams: undefined,
};

interface UseAmaStoreOutput extends AmaState {
	setState: (state: AmaState) => void;
	clearState: () => void;
}

export const useAmaStore = StoreHelper.createStore<UseAmaStoreOutput>(
	(set) => ({
		...initialAmaState,
		setState: function (state: AmaState) {
			set(
				produce((currentState: AmaState) => ({
					...currentState,
					...state,
				})),
				false,
				'setState'
			);
		},
		clearState: function () {
			set({ ...initialAmaState }, false, 'resetState');
		},
	}),
	{
		name: 'Ama',
		storage: createJSONStorage(() => sessionStorage),
	}
);
